import { Col, Row, Image } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { extractDate } from "../../config/helpers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { ADMIN, UPLOADS_URL } from "../../config/constants/api";
import { Put } from "../../config/api/put";
// import Swal from "sweetalert2";
import swal from "sweetalert";
import SystemRejectModal from "../../modals/SystemRejectModal";

const DriverDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [systemRejectModal, setSystemRejectModal] = useState(false);
  const [systemMessageModal2, setSystemMessageModal2] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const getUserDetails = () => {
    setLoading(true);
    Get(`${ADMIN.getChauffeur}${id}`, token)
      .then((response) => {
        setUserDetails(response?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching user details", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    console.log(systemMessageModal2);
    getUserDetails();
    // eslint-disable-next-line
  }, []);
  // const onChange = (checked) => {
  //   console.log(`switch to ${checked}`);
  //   handleClick(!active);
  // };
  const banUser = (id, status) => {
    let data = {};
    if (status === "REJECTED") {
      data = {
        status,
        rejectionReason,
      };
    } else {
      data = {
        status,
      };
    }
    Put(`${ADMIN.toggleChauffeur}${id}`, token, data)
      .then((response) => {
        if (response.status) {
          swal("System Alert!", response?.message, "success");
          getUserDetails();
          if(status === "REJECTED"){
            setSystemRejectModal(false);
          }
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  // const handleClick = (value) => {
  //   if (value) {
  //     Swal.fire({
  //       title: "System Alert!",
  //       text: "Are you sure you want to mark as active?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#18377E",
  //       cancelButtonColor: "#d33",
  //       cancelButtonText: "No",
  //       confirmButtonText: "Yes",
  //       showCloseButton: true,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         banUser(userDetails?._id, "ACTIVE", value);
  //       }
  //     });
  //   } else {
  //     Swal.fire({
  //       title: "System Alert!",
  //       text: "Are you sure you want to mark as inactive?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#18377E",
  //       cancelButtonColor: "#d33",
  //       cancelButtonText: "No",
  //       confirmButtonText: "Confirm",
  //       showCloseButton: true,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         banUser(userDetails?._id, "INACTIVE", value);
  //       }
  //     });
  //   }
  // };
  return (
    <Row justify="center">
      {!loading && <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-between mx-1 lg:mx-8 mb-4">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Driver Detail
              </h3>
            </div>
            <button
              className="uppercase bg-transparent border-2 border-customGold py-4 px-6 xl:px-16 text-customGold font-semibold rounded-lg text-sm max-md:text-[10px] max-md:py-2 max-md:px-4"
              onClick={() =>
                navigate("/reportManagement", { state: { chauffeurId: id } })
              }
            >
              see Bookings
            </button>
          </div>
          <Row justify="center">
            <Col xs={23}>
              <Row justify="center" gutter={[32, 16]} className="mb-6">
                <Col lg={12} xs={22}>
                  <div className="flex flex-col items-center justify-center h-full w-full">
                    <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-center justify-center sm:py-12 py-6 mb-8 w-full">
                      <h5 className="w-full text-start pl-8 mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                        Personal Information
                      </h5>
                      <img
                        style={{
                          height: "180px",
                          width: "180px",
                          borderRadius: "100%",
                          objectFit: "cover",
                          objectPosition: "center",
                        }}
                        src={UPLOADS_URL + userDetails?.image}
                        alt="profile"
                      />

                      <div className="flex justify-center items-center my-4 mx-2">
                        <div className="flex flex-col items-start 2xl:mr-32 mr-6">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Full Name
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {userDetails?.firstName} {userDetails?.lastName}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Contact Number
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {userDetails?.phone}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Birthday
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {extractDate(userDetails?.dateOfBirth)}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Driving license Expiry Date
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {extractDate(userDetails?.licenseExpiryDate)}
                          </p>
                        </div>
                        <div className="flex flex-col items-start">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Email Address
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {userDetails?.email}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Gender
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {userDetails?.gender}
                          </p>
                          {/* <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Sex Orientation
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            Straight
                          </p> */}
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Driving License No.
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {userDetails?.drivingLicenseNo}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:py-8 py-6 pl-8 w-full h-full">
                      <h5 className="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                        Payment Info
                      </h5>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Name of Bank
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {userDetails?.bankTitle}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Bank Account No.
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {userDetails?.bankAccountNo}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Routing Number
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-0">
                        {userDetails?.routingNo}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={12} xs={22}>
                  <div className="flex flex-col items-center justify-center h-full w-full">
                    {(userDetails?.dmvFront ||
                      userDetails?.dmvBack ||
                      userDetails?.tlcFront ||
                      userDetails?.tlcBack ||
                      userDetails?.insurance ||
                      userDetails?.registeration ||
                      userDetails?.licenseFront ||
                      userDetails?.licenseBack) && (
                      <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:py-8 py-6 pl-8 pr-12 w-full h-full">
                        <h5 className="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                          Documents
                        </h5>
                        <Image.PreviewGroup>
                          <Row gutter={[16, 16]} style={{ width: "100%" }}>
                            {userDetails?.licenseFront && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    License Front
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.licenseFront}
                                    alt="license front"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                            {userDetails?.licenseBack && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    License Back
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.licenseBack}
                                    alt="license back"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                            {userDetails?.dmvFront && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    DMV Front
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.dmvFront}
                                    alt="dmv front"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                            {userDetails?.dmvBack && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    DMV Back
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.dmvBack}
                                    alt="dmv back"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                            {userDetails?.tlcFront && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    TLC Front
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.tlcFront}
                                    alt="tlc front"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                            {userDetails?.tlcBack && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    TLC Back
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.tlcBack}
                                    alt="tlc back"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                            {userDetails?.insurance && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    Insurance
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.insurance}
                                    alt="insurance"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                            {userDetails?.registeration && (
                              <Col lg={12} xs={24}>
                                <div className="flex flex-col items-start justify-center">
                                  <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                                    Registration
                                  </h5>
                                  <Image
                                    src={UPLOADS_URL + userDetails?.registeration}
                                    alt="registration"
                                    style={{
                                      width: "100%",
                                      height: 180,
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      borderRadius: 8,
                                    }}
                                  />
                                </div>
                              </Col>
                            )}
                          </Row>
                        </Image.PreviewGroup>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="flex justify-start items-center max-lg:ml-6">
                {userDetails?.status === "ACTIVE" ? (
                  <button
                    className="uppercase bg-transparent py-4 px-6 xl:px-16 text-black border-2 border-black rounded-lg font-semibold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                    // onClick={() => handleInactiveDriver(item._id)}
                    onClick={() => {
                      banUser(userDetails?._id, "BANNED");
                    }}
                  >
                    Inactive driver
                  </button>
                ) : userDetails?.status === "BANNED" ? (
                  <button
                    className="uppercase bg-button py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                    // onClick={() => handleActivateDriver(item._id)}
                    onClick={() => {
                      banUser(userDetails?._id, "ACTIVE");
                    }}
                  >
                    Activate driver
                  </button>
                ) : (
                  <>
                    <button
                      className="uppercase bg-button py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                      // onClick={() => navigate("/approveDriver/" + item._id)}
                      onClick={() => {
                        banUser(userDetails?._id, "ACTIVE");
                      }}
                    >
                      Approve driver
                    </button>
                    <button
                      className="uppercase bg-transparent py-4 px-6 xl:px-16 text-black border-2 border-black rounded-lg font-semibold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                      // onClick={() => navigate("/rejectDriver/" + item._id)}
                      // onClick={() => {
                      //   banUser(userDetails?._id, "REJECTED");
                      // }}
                      onClick={() => setSystemRejectModal(true)}
                    >
                      Reject driver
                    </button>
                  </>
                )}
              </div>
              {/* <div className="flex justify-start items-center max-lg:ml-6">
                <button
                  className="uppercase bg-button py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                  onClick={() => navigate("/proveDriver")}
                >
                  Aprove driver
                </button>
                <button
                  className="uppercase bg-transparent py-4 px-6 xl:px-16 text-black border-2 border-black rounded-lg font-semibold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                  onClick={() => navigate("/rejectDriver")}
                >
                  Reject driver
                </button>
              </div> */}
            </Col>
          </Row>
        </div>
      </Col>}
      {systemRejectModal && (
        <SystemRejectModal
          systemRejectModal={systemRejectModal}
          setSystemRejectModal={setSystemRejectModal}
          setSystemMessageModal={setSystemMessageModal2}
          banUser={() => {
            banUser(userDetails?._id, "REJECTED");
           
          }}
          setRejectionReason={setRejectionReason}
          rejectionReason={rejectionReason}
        />
      )}
    </Row>
  );
};

export default DriverDetails;
